export default "__VITE_ASSET__b1d8d208__"